export const DepositActivityMovement = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
  IN_CONTAINER: 'in_container',
};
